import {
    postData,
    getData,
    uploadData,
    errorHelper
} from '@/store/config/methodCsrf'
const initialState = () => ({
    user: {verify_email: true, detail: {profile_picture: null}},
    data: {last_page: 0, data: [], total: 0},
    request: {
        page: 1,
        show: 9,
        sortBy: "created_at",
        sorting: "DESC",
        search: null
    },
    token: null,
    appkey: null,
    msg: 'Jaringan Bermasalah',
    status: 0
})
const state = initialState

function makeid() {
    let result = ''
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    for (let i = 0; i < 20; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }
 
const getters = {
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getToken: state => state.token,
    getAppkey: state => state.appkey,
    getUser: state => state.user || {verify_email: true, detail: {profile_picture: null}},
    getName: state => state.user?.name || null,
    getTempEmail: state => state.user?.temp_email,
    getEmail: state => state.user?.email,
    getRole: state => state.user?.role_code || null,
    getId: state => state.user?.id
}

const actions = {
    async loginUser({
        commit
    }, data) {
        try {
            var response = await postData('api','/login',data);
            if(response.data.status == 0){
                commit('SET_RESPONSE', response.data);
            }else{
                commit('SET_TOKEN', response.data)
            }
            return response.data
        } catch (err) {
            if(err.response.status == 401){
                commit('SET_RESPONSE', err.response);
            }else{
                commit('SET_FAILED')
            }
            return errorHelper(err)
        }
    },
    async logoutUser({
        commit
    }, data) {
        try {
            var response = await postData('api','/logout',data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async registrationJobSeeker({
        commit
    }, data){
        try {
            var response = await postData('api','/registration/jobseeker',data);
            commit('SET_TOKEN', response.data)
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async registrationCompany({
        commit
    }, data){
        try {
            const response = await postData('api','/registration/company',data);
            return response.data
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
            return { status: 0}
        }
    },
    async profilePictureUpload({
        commit
    }, {url, data}){
        try {
            var response = await postData('api',`/${url}`,data);
            commit('SET_USER', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async profile({
        commit
    }) {
        try {
            var response = await getData('api','/profile');
            commit('SET_USER', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async resendEmail({
        commit
    }) {
        try {
            var response = await getData('api','/resend-email');
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async resendEmailById({
        commit
    }, id) {
        try {
            var response = await getData('api',`/resend-email/${id}`);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async forgetPassword({
        commit
    }, data) {
        try {
            var response = await postData('api','/forget-password', data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async updateProfile({
        commit, dispatch
    }, data) {
        try {
            var response = await postData('api','/update-profile', data);
            if(!response.data.data.detail){
                dispatch('profile')
            }else{
                commit('SET_USER', response.data);
            }
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async updateDescription({
        commit
    }, data) {
        try {
            var response = await postData('api','/update-description', data);
            commit('SET_DESC', {response: response.data, desc: data.description});
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async uploadResume({
        commit
    }, data) {
        try {
            var response = await uploadData('api','/upload-resume', data);
            commit('SET_USER', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async setDetail({
        commit
    }, {name, data}) {
        commit('SET_DETAIL', {name, data});
    },
    async emailVerification({
        commit
    }, data){
        try {
            var response = await postData('api','/email-verification',data);
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async forgetPasswordVerification({
        commit
    }, data){
        try {
            var response = await postData('api','/forget-email-verification',data);
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async changeForgetPassword({
        commit
    }, data){
        try {
            var response = await postData('api','/change-forget-password',data);
            commit('SET_RESPONSE', response.data)
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async submit({
        commit
    }, {url, data}) {
        try {
            var response = await postData('api',`/${url}`,data);
            commit('SET_USER', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
    async changePassword({
        commit
    }, data) {
        try {
            var response = await postData('api','/user/changepassword',data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            commit('SET_FAILED_MSG', err.response)
        }
    },
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MSG(state, error) {
        if(error?.status == 400){
            state.msg = error.data.msg
            state.status = error.data.status
        }else{
            state.msg = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_USER(state, response) {
        state.msg = response.msg
        state.status = response.status
        state.user = {
            ...response.data,
            detail: response.data.detail || {
                educations: [],
                works: [],
                organizations: [],
                awards: [],
                social_medias: [],
                skills: [],
                files: [],
                languages: []
            }
        }
    },
    SET_DETAIL(state, {name, data}) {
        state.user.detail[name] = data
    },
    SET_DESC(state, {response, desc}) {
        state.msg = response.msg
        state.status = response.status
        state.user.detail.description = desc
    },
    SET_TOKEN(state, response) {
        state.message = response.message
        state.status = response.status
        state.user = response.data.user
        state.token = response.data.token
        const key = makeid()
        state.appkey = key
        localStorage.setItem('appkey', key)
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}